import { IAuthMeV2OutputDto } from '../interfaces';

export type AuthMeV1OutputDto = IAuthMeV2OutputDto;
